import { dynaMount } from '../utils/mountComponent';
import {
    EventCollections as EventCollectionsComponent,
    Props,
} from './EventCollections';

export const EventCollections: React.FC<Props> = (props) =>
    dynaMount(
        {
            Component: EventCollectionsComponent,
            containerId: 'listings-root__link-to-creator-collections',
        },
        props,
    );
